import React from "react";

export function StatItem({ value, description }) {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center py-4 text-center">
      <div className="display-4 fw-bold text-primary mb-2" style={{ color: '#0c4a6e !important' }}>
        {value}
      </div>
      <p className="mb-0 text-muted">
        {description}
      </p>
    </div>
  );
}
